<script>
  import { format } from 'svelte-i18n';
  import { Card, CardBody } from '@sveltestrap/sveltestrap';

  import { SwitchField } from '@client/components/fields/standalone';

  import { disabledValue, enabledValue } from '@client/pages/manage/domain-settings';

  export let settings = {};
  export let onUpdate = null;
</script>

<div>
  <h1 class="mb-3">{$format('label.GENERAL')}</h1>

  <Card>
    <CardBody class="p-4 pt-1">
      <SwitchField
        id="enableactivecompliance"
        label={$format('label.ACTIVE_TRACKING_COMPLIANCE')}
        tooltip={$format('label.TOOLTIP.ACTIVE_TRACKING_COMPLIANCE')}
        valueOn={$format(enabledValue)}
        valueOff={$format(disabledValue)}
        {onUpdate}
        bind:checked={settings.enableactivecompliance}
      />

      <SwitchField
        id="notifynoncompliance"
        label={$format('label.EMAIL_NON_COMPLIANCE_REPORT')}
        tooltip={$format('label.TOOLTIP.EMAIL_NON_COMPLIANCE_REPORT')}
        valueOn={$format(enabledValue)}
        valueOff={$format(disabledValue)}
        {onUpdate}
        bind:checked={settings.notifynoncompliance}
      />
    </CardBody>
  </Card>
</div>

<style lang="scss" src="./compliance.scss"></style>
